module.exports = __webpack_public_path__ + "static/media/sort-up.13069be2.svg";